import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46749123"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-overlay" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", {
      tabindex: "0",
      class: "inner"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_2 = {
  class: "popup-root",
  ref: "popupRoot"
}
const _hoisted_3 = {
  class: "popup-floater",
  ref: "floater"
}
const _hoisted_4 = {
  class: "popup-dialog",
  role: "dialog",
  tabindex: "-1"
}
const _hoisted_5 = { class: "popup-content-container" }
const _hoisted_6 = { class: "popup-header-container" }
const _hoisted_7 = { class: "popup-header-text" }
const _hoisted_8 = { class: "scroller" }
const _hoisted_9 = { class: "popup-content-body" }
const _hoisted_10 = { class: "content-form" }
const _hoisted_11 = { class: "submit-container" }
const _hoisted_12 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "popup-container",
            style: _normalizeStyle({ width: $props.width + 'px' })
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString($props.title), 1 /* TEXT */),
                  _createElementVNode("div", { style: {"display":"inline-block"} }, [
                    _createElementVNode("div", { class: "popup-header-closebutton-container" }, [
                      _createElementVNode("button", {
                        onClick: $setup.close,
                        tabindex: "0",
                        title: "Close dialog",
                        "data-eventutils-optout": "true",
                        class: "popup-header-closebutton-button low-density"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("form", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["submit-message", {
                          'stm-info': $props.status === 'idle' || $props.status === 'loading',
                          'stm-success': $props.status === 'success',
                          'stm-error': $props.status === 'error',
                        }])
                        }, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString($props.statusMessage), 1 /* TEXT */),
                          ($props.statusLink)
                            ? (_openBlock(), _createBlock($setup["TableauLink"], {
                                key: 0,
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($props.statusLink.action()), ["stop","prevent"])),
                                class: "link"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($props.statusLink.text), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */),
                        _createVNode($setup["TableauButton"], {
                          type: "submit",
                          text: $props.submitText,
                          disabled: !$props.canSubmit,
                          isLoading: $props.status === 'loading',
                          onClicked: _cache[1] || (_cache[1] = ($event: any) => ($setup.emits('submitted')))
                        }, null, 8 /* PROPS */, ["text", "disabled", "isLoading"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ], 4 /* STYLE */)
        ], 512 /* NEED_PATCH */)
      ])
    ], 512 /* NEED_PATCH */)
  ], 64 /* STABLE_FRAGMENT */))
}